module.exports = __webpack_public_path__ + "img/service_companies.1807e17c.jpg";